import { Box } from '@mui/material';
import styled from 'styled-components';

export const SubscriptionLockWrapper = styled(Box)`
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
`;
